import React from 'react';

import { enumHelper } from '../../../utils';
import ENUMS from '../../../enums';

import ShowForPermission from '../../../components/ShowForPermission';

import styles from './styles.scss';

function ReservesReportListTableRow(props) {
  const displayReserveDetailsModal = e => {
    e.preventDefault();

    props.displayReserveDetailsModal(props.id);
  };

  const displayInvoiceModal = e => {
    e.preventDefault();

    props.displayInvoiceModal(props.id);
  };

  return (
    <tr className={`${props.isSuspended ? 'danger-row' : ''}`}>
      <td className="text-center">{(props.currentPage - 1) * props.itemsPerPage + props.ix + 1}</td>
      <td className={`text-center ${styles.reserveCreatorCell}`} title={props.createdFullName}>
        {props.createdFullName}
      </td>
      <td className="text-center">{props.startAt}</td>
      <td className="text-center">{props.endAt}</td>
      <td className="text-center">
        {props.reservedTables &&
        props.reservedTables.length &&
        props.reservedTables.map(
          (ele, index, self) => ` ${ele.num} ${index < self.length - 1 ? '،' : ''}`,
        )}
      </td>
      <td className="text-center">
        {enumHelper.convertEnumValueToTitle(ENUMS.RESERVATION_TYPES.list, props.reserveType)}
      </td>
      <td className="text-center direction-ltr">{props.trackingNumber}</td>
      <td className="text-center">{props.persons}</td>
      <td className="text-center">
        {props.meal &&
        props.meal.length &&
        enumHelper.convertEnumValueToTitle(ENUMS.MEAL_PORTIONS.list, props.meal)}
      </td>
      <td className={`text-center ${props.renderStatusColors(props.status)}`}>
        {enumHelper.convertEnumValueToTitle(ENUMS.CAFE_RESERVATION.list, props.status)}
      </td>
      <ShowForPermission permission={ENUMS.PERMISSIONS.values.VIEW_ARCHIVE_RESERVES_FOR_ADMIN}>
        <td className="text-center">{props.cafeName}</td>
      </ShowForPermission>
      <td className="text-center">
        <ShowForPermission permission={ENUMS.PERMISSIONS.values.VIEW_RESERVE_DETAILS}>
          <a
            href="#"
            title={locales('titles.reserveMoreInfo')}
            onClick={displayReserveDetailsModal}
            className="pointer"
          >
            <i className="text-center far fa-info-circle pointer"/>
          </a>
        </ShowForPermission>
      </td>
      {/* <td className="text-center pointer">
        {props.status === ENUMS.CAFE_RESERVATION.values.FINISHED && (
          <a
            href="#"
            title={locales('titles.seeFactorDetails')}
            onClick={displayInvoiceModal}
            className="pointer"
          >
            <i className="text-center fal fa-receipt pointer"/>
          </a>
        )}
      </td> */}
    </tr>
  );
}

export default ReservesReportListTableRow;
